// flow weak
// #region imports
import "babel-polyfill";
import "react-app-polyfill/ie11";
// import 'react-app-polyfill/stable';
import "regenerator-runtime";
import React from "react";
import { render, BrowserRouter, ReactDOM } from "react-dom";
import { AppContainer } from "react-hot-loader";
import smoothScrollPolyfill from "smoothscroll-polyfill";
import injectTpEventPlugin from "react-tap-event-plugin";
import "jquery";
import "./style/director-style.css";
// import "./style/highlight/darkula.css";
import "./style/index.style.scss";
import Root from "./Root";

const ELEMENT_TO_BOOTSTRAP = "root";
const BootstrapedElement = document.getElementById(ELEMENT_TO_BOOTSTRAP);
smoothScrollPolyfill.polyfill();
window.__forceSmoothScrollPolyfill__ = true;
// #endregion

const renderApp = (RootComponent) => {
  render(
    <AppContainer warning={false}>
      <RootComponent />
    </AppContainer>,
    BootstrapedElement
  );
};

renderApp(Root);

if (module.hot) {
  module.hot.accept("./Root", () => {
    const RootComponent = require("./Root").default;
    renderApp(RootComponent);
  });
}



// WEBPACK FOOTER //
// ./src/app/index.js